<template>
  <div ref="aboveRoot" class="above-the-fold skinc-container">
    <video
      ref="backgroundVideo"
      class="background-video"
      :class="{ 'is-visible': isVideoVisible }"
      autoplay
      muted
      playsinline
    >
      <source src="/static_img/skinc/abovethefold/main_video_2.mp4" type="video/mp4" />
      브라우저가 비디오 태그를 지원하지 않습니다.
    </video>
    <div></div>
    <slogan class="mobile-margin" />

    <div class="bottom-container">
      <a
        v-for="(item, index) in bottomNavItems"
        :key="item.id"
        :href="item.url"
        :style="{ 'animation-delay': 0.4 + index * 0.2 + 's' }"
        target="_blank"
        rel="noopener noreferrer"
        class="info-btn"
      >
        <div v-html="item.svgIcon"></div>
        <h5>{{ item.text }}</h5>
      </a>
    </div>
  </div>
</template>

<script>
import slogan from './slogan.vue';
import { mapState } from 'vuex';
import { getBottomNavItems } from '@/components/main_pages/skinc/skincData.js';

export default {
  name: 'AboveTheFold',
  components: {
    slogan: slogan
  },
  data() {
    return {
      isVideoVisible: false
    };
  },
  computed: {
    ...mapState('report_list', ['lang']),
    bottomNavItems() {
      return getBottomNavItems(this.lang);
    }
  },
  mounted() {
    const video = this.$refs.backgroundVideo;
    if (video) {
      this.videoElement = video;
      this.videoElement.addEventListener('playing', this.fadeInVideo);
      this.videoElement.addEventListener('ended', this.fadeOutAndLoop);
    }
  },
  beforeDestroy() {
    if (this.videoElement) {
      this.videoElement.removeEventListener('playing', this.fadeInVideo);
      this.videoElement.removeEventListener('ended', this.fadeOutAndLoop);
    }
  },
  methods: {
    fadeInVideo() {
      this.isVideoVisible = true;
    },
    fadeOutAndLoop() {
      this.isVideoVisible = false;
      setTimeout(() => {
        if (this.$refs.backgroundVideo) {
          this.$refs.backgroundVideo.currentTime = 0;
          this.$refs.backgroundVideo.play();
        }
      }, 500);
    }
  }
};
</script>

<style scoped>
.above-the-fold {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  overflow: hidden;
}

.above-the-fold > * {
  position: relative;
  z-index: 2;
}

.background-video {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  min-width: 100vw;
  min-height: 100vh;
  width: auto;
  height: auto;
  z-index: 1;
  object-fit: cover;
  opacity: 0.5;
  transition: opacity 0.5s ease-in-out;
}

.background-video.is-visible {
  opacity: 1;
}

.bottom-container {
  width: 100%;
  display: flex;
  gap: 1vw;
}

.info-btn {
  flex: 1;
  padding: clamp(0.75rem, 3vw, 2rem) clamp(0.6rem, 2vw, 1.5rem);
  box-sizing: border-box;
  background-color: transparent;
  border: none;
  border-top: 1px solid #ffffff;
  color: #ffffff;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  position: relative;
  isolation: isolate;
  opacity: 0;
  animation-name: fadeInFromTop;
  animation-duration: 0.8s;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
}

.info-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 75%);
  z-index: -1;
}

.info-btn h5 {
  margin: 0;
  font-weight: 500;
  font-size: clamp(16px, 1vw + 0.5rem, 23px);
  white-space: nowrap;
}

.info-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

@keyframes fadeInFromTop {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 992px) {
  .bottom-container {
    flex-wrap: wrap;
  }

  .info-btn {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 46%;
  }
}

@media screen and (max-width: 576px) {
  .above-the-fold {
    min-height: 140vh;
  }

  .background-video {
    min-height: 140vh;
    opacity: 1;
  }

  .info-btn {
    flex-basis: 100%;
  }

  .info-btn:nth-child(odd) {
    border-right: none;
  }

  .mobile-margin {
    margin-top: 10vh;
  }
}
</style>
